import { createSelector } from 'reselect';
import { CARD_IDENTIFICATION_STATUS, CARD_STATUS } from '../constants';
import { getCardInfo } from './commonSelectors';

export const selectIsIdentified = createSelector(getCardInfo, ({ data }) => {
  return data?.status === CARD_STATUS.SIMPLY_IDENTIFIED;
});

export const selectIsIdentificationInProgress = createSelector(getCardInfo, ({ data }) => {
  return data?.identification?.status === CARD_IDENTIFICATION_STATUS.INIT;
});
